import Section from './section.model';

export default class ConfigProfile {

    public id: number = 0;
    public sections:Array<Section> = [];

    constructor(){
    }

    init(){
        this.id = 0;
        this.sections = [];
    }
}